module.exports = __webpack_public_path__ + "static/img/tkb.7c0aeb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tkb.png
// module id = SW56
// module chunks = 1